// The review thread the Files view was asked to show (`?thread=`). A
// thread starts collapsed when resolved; the one named here opens, so a
// link into it (the header's unresolved items, the Overview's Links card)
// lands on its comments. Node IDs are unique, so one value serves every
// pull request.

/** One request to show a thread. `n` makes each request new, even for the same thread. */
export interface RevealRequest {
  id: string;
  n: number;
}

class Reveal {
  /** The request not yet answered, if any. Raw, not proxied: `done` compares requests by identity. */
  request: RevealRequest | null = $state.raw(null);
  private count = 0;

  /** Ask for thread `id` to be shown (again, if it was before). */
  show(id: string): RevealRequest {
    return (this.request = { id, n: ++this.count });
  }

  /** The view has answered `request` (shown it, or given up): it no longer applies, unless a newer one replaced it. */
  done(request: RevealRequest | null) {
    if (request && this.request === request) this.request = null;
  }
}

export const reveal = new Reveal();
